import React from 'react';
import { useParams } from 'react-router-dom';
import { getAllProducts } from '../data/productos';
import ProductDestacado from './products/ProductDestacado';
import ProductCocina from './products/ProductCocina';
import ProductDormitorio from './products/ProductDormitorio';
import ProductLiving from './products/ProductLiving';
import ProductPlacards from './products/ProductPlacards';
import ProductEntretenimiento from './products/ProductEntretenimiento';

const ProductRouter = () => {
  const { productId } = useParams();
  const allProducts = getAllProducts();
  const product = allProducts[productId];

  if (!product) {
    return (
      <div className="product-page">
        <div className="error-container">
          <h1 className="error-title">Producto no encontrado</h1>
          <p className="error-message">El producto que buscas no existe o ha sido removido.</p>
          <button onClick={() => window.location.href = '/'} className="error-button">
            Volver al inicio
          </button>
        </div>
      </div>
    );
  }

  // Determinar qué componente usar basado en la categoría del producto
  switch (product.category) {
    case 'destacados':
      return <ProductDestacado />;
    case 'cocina':
      return <ProductCocina />;
    case 'dormitorio':
      return <ProductDormitorio />;
    case 'living':
      return <ProductLiving />;
    case 'placards':
      return <ProductPlacards />;
    case 'entretenimiento':
      return <ProductEntretenimiento />;
    default:
      return (
        <div className="product-page">
          <div className="error-container">
            <h1 className="error-title">Categoría no válida</h1>
            <p className="error-message">La categoría del producto no es válida.</p>
            <button onClick={() => window.location.href = '/'} className="error-button">
              Volver al inicio
            </button>
          </div>
        </div>
      );
  }
};

export default ProductRouter;

